import { z } from 'zod'

import { ProErrorSchema } from 'shared/api/common/schemas/errors'

const ZapSchema = z.object({
  event_id: z.number(),
  page_id: z.number(),
  event_normalized: z.string(),
  event_name: z.string(),
  ts_created: z.number(),
  ts_updated: z.number().nullable(),
  active: z.boolean(),
})

export const ZapierSchemas = {
  fetchZaps: {
    response: z.object({
      events: z.array(ZapSchema),
    }),
    request: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
  createZap: {
    response: z.object({
      event: ZapSchema,
    }),
    request: z.undefined(),
    query: z.object({
      event_name: z.string(),
    }),
    path: z.undefined(),
    errors: {
      ProError: ProErrorSchema,
    },
  },
}

export type BackendZap = z.infer<typeof ZapSchema>
